import * as types from './actionTypes';

const initialState = {
  exemptionlist: [],
  loading: false,
  error: null,
  success: false, // ✅ New field to track success
};

const employeeExemptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_EMPLOYEE_EXEMPTIONS:
    case types.SAVE_EMPLOYEE_EXEMPTION:
    case types.CHANGE_EMPLOYEE_EXEMPTION_STATUS:
      return {
        ...state,
        loading: true,
        error: null,
        success: false, // Reset on request
      };

    case types.GET_EMPLOYEE_EXEMPTIONS_SUCCESS:
      return {
        ...state,
        exemptionlist: action.payload?.data,
        loading: false,
      };

    case types.SAVE_EMPLOYEE_EXEMPTION_SUCCESS:
      return {
        ...state,
        // exemptionlist: [
        //   ...state.exemptionlist.filter(item => item.id !== action.payload.id),
        //   action.payload
        // ],
        loading: false,
        success: true, // ✅ Mark success
      };

    case types.CHANGE_EMPLOYEE_EXEMPTION_STATUS_SUCCESS:
      return {
        ...state,
        // exemptionlist: state.exemptionlist.map(item =>
        //   item.id === action.payload.id
        //     ? { ...item, status: action.payload.status }
        //     : item
        // ),
        loading: false,
        success: true, // ✅ Mark success
      };

    case types.EMPLOYEE_EXEMPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export default employeeExemptionReducer;
